import { useEffect, useState } from "react";
import { getGenres, getLanguages } from "../../services/eventService";

export default function EventDetails() {
  const [genres, setGenres] = useState([]);
  const [languages, setLanguages] = useState([]);

 useEffect(() => {
   getGenres()
     .then((res) => setGenres(res.data))
     .catch((err) => console.error("Genre fetch error:", err));
      getLanguages()
          .then((res) => setLanguages(res.data))
          .catch((err) => console.error("Language fetch error:", err));
 }, []);

  return (
    <div className="mb-12">
      <h2 className="text-lg font-medium mb-8">Event Details</h2>

      <div className="grid md:grid-cols-2 gap-8">

        {/* Event Name */}
        <input
          name="eventName"
          required
          placeholder="Event Name"
          className="input-style"
        />

        {/* Free / Paid */}
        <select
          name="eventType"
          required
          className="input-style"
        >
          <option value="">Free / Paid</option>
          <option value="FREE">Free</option>
          <option value="PAID">Paid</option>
        </select>

        {/* Genre API Dropdown */}
        <select
          name="genreId"
          required
          className="input-style"
        >
          <option value="">Select Genre</option>
          {genres.map((genre) => (
            <option key={genre.id} value={genre.id}>
              {genre.name}
            </option>
          ))}
        </select>

        {/* Language API Dropdown */}
        <select
          name="languageId"
          required
          className="input-style"
        >
          <option value="">Select Language</option>
          {languages.map((language) => (
            <option key={language.id} value={language.id}>
              {language.languageName}
            </option>
          ))}
        </select>

      </div>

      {/* Description */}
      <textarea
        name="eventDescription"
        required
        placeholder="Event Description"
        className="input-style-new mt-8 h-28 resize-none"
      />

      {/* termsConditions */}
        <textarea
          name="termsConditions"
          placeholder="Event Term and Conditions"
          className="input-style-new mt-8 h-28 resize-none"
        />
    </div>
  );
}